import { ROLES } from "../model/user.model";

export class Route {
    path: string = "";
    absolute_path: string = "";
    roles: ROLES[] = [];
}

export abstract class ROUTES {

    // HOME
    static readonly PRE_LANDING: Route = {
        path: "landing",
        absolute_path: "/landing",
        roles: []
    };

    static readonly NOT_ALLOWED: Route = {
        path: "not-allowed",
        absolute_path: "/not-allowed",
        roles: []
    };

    static readonly MESSAGE: Route = {
        path: "message",
        absolute_path: "/message",
        roles: []
    };

    static readonly LOGIN: Route = {
        path: "login",
        absolute_path: "/login",
        roles: []
    };

    static readonly HOME: Route = {
        path: "home",
        absolute_path: "/home",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    };

    static readonly EVENT_LIST: Route = {
        path: "eventi",
        absolute_path: "/eventi",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly EVENT_SELECT_PROFILE: Route = {
        path: "eventi/seleziona-profilo",
        absolute_path: "/eventi/seleziona-profilo",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly EVENT_CALENDAR: Route = {
        path: "eventi/calendario",
        absolute_path: "/eventi/calendario",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly EVENT_SUMMARY: Route = {
        path: "eventi/riepilogo",
        absolute_path: "/eventi/riepilogo",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly EVENT_CONFIRMATION: Route = {
        path: "eventi/esito-prenotazione",
        absolute_path: "/eventi/esito-prenotazione",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly EVENT_EDIT: Route = {
        path: "eventi/modifica-prenotazione",
        absolute_path: "/eventi/modifica-prenotazione",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly EVENT_DELETE: Route = {
        path: "eventi/elimina-prenotazione",
        absolute_path: "/eventi/elimina-prenotazione",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    // RESERVATIONS
    static readonly RESERVATION: Route = {
        path: "prenotazione",
        absolute_path: "/prenotazione",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly RESERVATION_LIST: Route = {
        path: "prenotazioni",
        absolute_path: "/prenotazioni",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }
    

    //FLUX ROUTES
    static readonly FLUX_HOME: Route = {
        path: ":flux/home",
        absolute_path: "/:flux/home",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    };
    
    static readonly FLUX_EVENT_LIST: Route = {
        path: ":flux/eventi",
        absolute_path: "/:flux/eventi",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly FLUX_EVENT_SELECT_PROFILE: Route = {
        path: ":flux/eventi/seleziona-profilo",
        absolute_path: "/:flux/eventi/seleziona-profilo",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly FLUX_EVENT_CALENDAR: Route = {
        path: ":flux/eventi/calendario",
        absolute_path: "/:flux/eventi/calendario",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly FLUX_EVENT_SUMMARY: Route = {
        path: ":flux/eventi/riepilogo",
        absolute_path: "/:flux/eventi/riepilogo",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly FLUX_EVENT_CONFIRMATION: Route = {
        path: ":flux/eventi/esito-prenotazione",
        absolute_path: "/:flux/eventi/esito-prenotazione",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly FLUX_EVENT_EDIT: Route = {
        path: ":flux/eventi/modifica-prenotazione",
        absolute_path: "/:flux/eventi/modifica-prenotazione",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly FLUX_EVENT_DELETE: Route = {
        path: ":flux/eventi/elimina-prenotazione",
        absolute_path: "/:flux/eventi/elimina-prenotazione",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly FLUX_RESERVATION: Route = {
        path: ":flux/prenotazione",
        absolute_path: "/:flux/prenotazione",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }

    static readonly FLUX_RESERVATION_LIST: Route = {
        path: ":flux/prenotazioni",
        absolute_path: "/:flux/prenotazioni",
        roles: [ROLES.PASSEGGERO, ROLES.OPERATORE, ROLES.ADMIN]
    }
    // Add new Routes here
}